import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import DateFnsUtils from '@date-io/date-fns'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { StylesProvider } from '@material-ui/styles'
import { ThemeProvider } from 'styled-components'
import maTheme from './theme'
import Routes from './routes/Routes'
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'
import English from './locale/en.json'
import German from './locale/de.json'
import Hebrew from './locale/he.json'
import Spanish from './locale/es.json'
import Russian from './locale/ru.json'
import axios from 'axios'
import { userLocalStorage } from 'config/local_storage'

let authToken
axios.interceptors.request.use(c => {
  if (authToken) {
    const header = {
      Accept: 'application/json',
      Authorization: 'Bearer ' + authToken,
    }
    c.headers = header
  }
  return c
})
i18next.init({
  // language to use
  fallbackLng: 'en',

  interpolation: { escapeValue: false },
  // React already does escaping
  lng: 'en',
  resources: {
    de: {
      common: German,
    },
    en: {
      Ten: English,
      common: English,
      emailBlock: English,
      language: English,
      mobileBlock: English,
      payments: English,
      profile: English,
      registration: English,
      stepper: English,
    },
    es: {
      Ten: Spanish,
      common: Spanish,
      emailBlock: Spanish,
      language: Spanish,
      mobileBlock: Spanish,
      payments: Spanish,
      profile: Spanish,
      stepper: Spanish,
    },
    he: {
      Ten: Hebrew,
      common: Hebrew,
      emailBlock: Hebrew,
      language: Hebrew,
      mobileBlock: Hebrew,
      payments: Hebrew,
      profile: Hebrew,
      stepper: Hebrew,
    },
    ru: {
      Ten: Russian,
      common: Russian,
      emailBlock: Russian,
      language: Russian,
      mobileBlock: Russian,
      payments: Russian,
      profile: Russian,
      registration: Russian,
      stepper: Russian,
    },
    us: {
      common: English, // 'common' is our custom namespace
    },
  },
})

function App({ theme, token }) {
  authToken = token
  const language = new URLSearchParams(window.location.search).get('lang')
  const localStorageLangugage = userLocalStorage.get('lang')
  React.useEffect(() => {
    const lang = language || localStorageLangugage
    if (lang === 'he') {
      document.body.style.direction = 'rtl'
    } else {
      document.body.style.direction = 'ltr'
    }
    if (lang) {
      userLocalStorage.set('lang', lang.toLowerCase())
    }
  }, [])
  return (
    <React.Fragment>
      <I18nextProvider i18n={i18next}>
        <Helmet titleTemplate="%s | Bnei Baruch Convention" defaultTitle="User Registration" />
        <StylesProvider injectFirst>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <MuiThemeProvider theme={maTheme[theme.currentTheme]}>
              <ThemeProvider theme={maTheme[theme.currentTheme]}>
                <Routes />
              </ThemeProvider>
            </MuiThemeProvider>
          </MuiPickersUtilsProvider>
        </StylesProvider>
      </I18nextProvider>
    </React.Fragment>
  )
}

App.propTypes = {
  theme: PropTypes.shape({
    currentTheme: PropTypes.number,
  }),
  token: PropTypes.string,
}

export default connect(store => ({ theme: store.registrationReducer, token: store.registrationReducer.token }))(App)
